module.exports = __webpack_public_path__ + "static/img/statusWrong.16444e57.png";